import React from 'react';

import { useIntlDictionary } from 'hooks/useIntlDictionary';
import { ClientProduct } from 'types/clientProductTypes';
import { SidebarModalSectionComponent } from 'design/sidebarModal';
import { TextComponent } from 'design/text/textComponents';
import {
  SmallTableRowComponent,
  SmallTableWrapperComponent,
} from 'design/smallTable';
import { ModalPressControlComponent } from 'design/modalPressControl';

type Props = {
  clientProducts: ClientProduct[];
  onEditProduct(productId: number): void;
};

export const ClientDetailsProducts = (props: Props) => {
  const { clientProducts, onEditProduct } = props;

  const {
    clientDetails: { productsScreen: ownDictionary },
  } = useIntlDictionary();

  const createEditProductHandler = React.useCallback(
    (id: number) => {
      return () => {
        onEditProduct(id);
      };
    },
    [onEditProduct]
  );

  return (
    <>
      {clientProducts.map((clientProduct) => (
        <SidebarModalSectionComponent
          key={clientProduct.id}
          content={
            <>
              <SmallTableWrapperComponent>
                <SmallTableRowComponent>
                  <TextComponent>
                    {ownDictionary.productDescriptionLabel}
                  </TextComponent>
                  <TextComponent>{clientProduct.description}</TextComponent>
                </SmallTableRowComponent>
                <SmallTableRowComponent>
                  <TextComponent>{ownDictionary.agmPartLabel}</TextComponent>
                  <TextComponent>
                    <span>
                      <TextComponent>
                        {ownDictionary.percentValue(
                          clientProduct.calculation.agmPercent
                        )}
                      </TextComponent>{' '}
                      <TextComponent color="secondary">
                        {ownDictionary.amountValue(
                          clientProduct.calculation.agmAmount
                        )}
                      </TextComponent>
                    </span>
                  </TextComponent>
                </SmallTableRowComponent>
                <SmallTableRowComponent>
                  <TextComponent>
                    {ownDictionary.partnerPartLabel}
                  </TextComponent>
                  <TextComponent>
                    <span>
                      <TextComponent>
                        {ownDictionary.percentValue(
                          clientProduct.calculation.partnerPercent
                        )}
                      </TextComponent>{' '}
                      <TextComponent color="secondary">
                        {ownDictionary.amountValue(
                          clientProduct.calculation.partnerAmount
                        )}
                      </TextComponent>
                    </span>
                  </TextComponent>
                </SmallTableRowComponent>
                <SmallTableRowComponent>
                  <TextComponent>
                    {ownDictionary.discountPartLabel}
                  </TextComponent>
                  <TextComponent>
                    <span>
                      <TextComponent>
                        {ownDictionary.percentValue(
                          clientProduct.calculation.discountPercent
                        )}
                      </TextComponent>{' '}
                      <TextComponent color="secondary">
                        {ownDictionary.amountValue(
                          clientProduct.calculation.discountAmount
                        )}
                      </TextComponent>
                    </span>
                  </TextComponent>
                </SmallTableRowComponent>
                <SmallTableRowComponent>
                  <TextComponent>{ownDictionary.tariffLabel}</TextComponent>
                  <TextComponent>
                    <span>
                      <TextComponent>
                        {ownDictionary.tariffAmountValue(
                          clientProduct.calculation.tariffAmount
                        )}
                      </TextComponent>{' '}
                      {clientProduct.calculation.discountPercent > 0 && (
                        <TextComponent color="secondary">
                          {ownDictionary.tariffPercentValue(
                            clientProduct.calculation.discountPercent
                          )}
                        </TextComponent>
                      )}
                    </span>
                  </TextComponent>
                </SmallTableRowComponent>
              </SmallTableWrapperComponent>
            </>
          }
          actions={
            <>
              <ModalPressControlComponent
                type="button"
                theme="secondary"
                onPress={createEditProductHandler(clientProduct.id)}
              >
                {ownDictionary.editProductActionText}
              </ModalPressControlComponent>
            </>
          }
        />
      ))}
    </>
  );
};
